/* ============================================================
   Cattle Cams — mobile navigation enhancer
   Adds a hamburger toggle + slide-down menu on phones.
   Desktop is untouched: the toggle is display:none above 760px
   and the menu markup is the existing .nav-links list.
   Works for BOTH the React-rendered nav (index/build) and the
   static-HTML navs (parts/story/support/videos) via a one-shot
   MutationObserver that enhances each .nav-row when it appears.
   ============================================================ */
(function () {
  var PHONE = "(605) 622-0676";

  function enhance(navRow) {
    if (!navRow || navRow.dataset.mobileReady === "1") return;
    var links = navRow.querySelector(".cc-nav-links");
    var actions = navRow.querySelector(".cc-nav-actions");
    var header = navRow.closest(".cc-nav");
    if (!links || !header) return;
    navRow.dataset.mobileReady = "1";

    // --- tap-to-call link, shown only inside the open mobile menu ---
    if (!links.querySelector(".cc-nav-mobile-call")) {
      var call = document.createElement("a");
      call.className = "cc-nav-mobile-call";
      call.href = "tel:6056220676";
      call.innerHTML = '<span class="cc-nav-mobile-call-bolt">\u260E</span> ' + PHONE;
      links.appendChild(call);
    }

    // --- hamburger button ---
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "cc-nav-toggle";
    btn.setAttribute("aria-label", "Open menu");
    btn.setAttribute("aria-expanded", "false");
    btn.innerHTML = '<span class="cc-nav-toggle-bars"><i></i><i></i><i></i></span>';
    if (actions) navRow.insertBefore(btn, actions);
    else navRow.appendChild(btn);

    function open() {
      header.classList.add("cc-nav-open");
      btn.setAttribute("aria-expanded", "true");
      btn.setAttribute("aria-label", "Close menu");
      document.body.classList.add("cc-nav-locked");
    }
    function close() {
      header.classList.remove("cc-nav-open");
      btn.setAttribute("aria-expanded", "false");
      btn.setAttribute("aria-label", "Open menu");
      document.body.classList.remove("cc-nav-locked");
    }
    function toggle() {
      if (header.classList.contains("cc-nav-open")) close();
      else open();
    }

    btn.addEventListener("click", function (e) {
      e.stopPropagation();
      toggle();
    });
    // close when a menu link is tapped
    links.addEventListener("click", function (e) {
      if (e.target.closest("a")) close();
    });
    // close on outside tap
    document.addEventListener("click", function (e) {
      if (!header.classList.contains("cc-nav-open")) return;
      if (!e.target.closest(".cc-nav")) close();
    });
    // close on escape
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
    // close if we grow back to desktop
    window.addEventListener("resize", function () {
      if (window.innerWidth > 760) close();
    });
  }

  function scan() {
    var rows = document.querySelectorAll(".cc-nav-row");
    for (var i = 0; i < rows.length; i++) enhance(rows[i]);
  }

  if (document.readyState !== "loading") scan();
  else document.addEventListener("DOMContentLoaded", scan);

  // React navs mount after Babel finishes — watch for them.
  if (window.MutationObserver) {
    var mo = new MutationObserver(scan);
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // stop observing after things settle to keep it cheap
    setTimeout(function () { mo.disconnect(); }, 8000);
  }
})();
